import * as Icons from "@nova/component-icons"
import { EventKind } from "@nova/schemas"
import { Notification } from "../Notification"
import { AvatarIcon } from "../NotificationIcons"
import { NotificationKindProps } from "./types"

type StreamKind =
    | EventKind.StreamStarted
    | EventKind.StreamShared
    | EventKind.MissionGroupStreamShared
    | EventKind.MissionGroupDashboardShared

export const StreamNotification = ({
    notification,
    copy,
    actorName,
}: NotificationKindProps<StreamKind>) => (
    <Notification notification={notification}>
        <Notification.Icon>
            <AvatarIcon userId={notification.createdBy} fullName={actorName} />
        </Notification.Icon>
        <Notification.Content>
            <Notification.Heading>
                <Notification.Title>{copy.title}</Notification.Title>
                {copy.subtitle && <Notification.Subtitle>{copy.subtitle}</Notification.Subtitle>}
            </Notification.Heading>
            {notification.projectId &&
                notification.kind !== EventKind.MissionGroupDashboardShared && (
                    <Notification.Action
                        label="View Livestream"
                        RightIcon={
                            notification.kind === EventKind.MissionGroupStreamShared
                                ? Icons.OpenInNew
                                : Icons.PlayCircle
                        }
                        to={{ projectId: notification.projectId }}
                    />
                )}
        </Notification.Content>
    </Notification>
)
